import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraHubCard } from '../lieutenants/hub-card';
const columnClass = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-2 lg:grid-cols-3',
    4: 'md:grid-cols-2 lg:grid-cols-4'
};
/** Responsive collection of cross-product or program destination cards. */ export const SpecraHubGrid = /*#__PURE__*/ React.forwardRef(({ className, columns = 3, getItemProps, getItemTestId, items, renderLink, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        className: cn('grid gap-3', columnClass[columns], className),
        ref: ref,
        ...props,
        children: items.map((item)=>{
            const { id, ...card } = item;
            return /*#__PURE__*/ _createElement(SpecraHubCard, {
                ...card,
                ...getItemProps?.(item),
                "data-item-id": id,
                "data-testid": getItemTestId?.(item),
                key: id,
                renderLink: renderLink
            });
        })
    }));
SpecraHubGrid.displayName = 'SpecraHubGrid';
